import { Component } from '@angular/core';
import { StatusCategoryService } from '../status-category.service';
import { StatusCategory } from '../status-category';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-status-category-edit',
  templateUrl: 'edit.component.html',
})
export class StatusCategoryEditComponent {
  /**
   * Details of the statusCategory being edited.
   */
  public statusCategory: StatusCategory;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {StatusCategoryService} statusCategoryService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private statusCategoryService: StatusCategoryService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.statusCategoryService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadStatusCategory(params.id));
  }

  /**
   * Perform the edit action which send the edited statusCategory to the backend.
   */
  public edit() {
    const editStatusCategory = this.statusCategoryService
      .updateStatusCategory(this.statusCategory.id, this.statusCategory)
      .subscribe(
        (result: StatusCategory) => {
          this.notificationService.success(
            `StatusCategory Updated`,
            `The statusCategory ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.statusCategory = new StatusCategory();
          editStatusCategory.unsubscribe();
          this.router.navigate(['/status-categories']);
        },
        err => {
          this.notificationService.error(
            `StatusCategory Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/status-categories']);
        },
      );
  }

  /**
   * Loads the requested statusCategory so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadStatusCategory(id: string) {
    this.statusCategoryService.findStatusCategory(id).subscribe(
      result => {
        this.statusCategory = result;
      },
      err => {
        this.notificationService.error(
          `StatusCategory Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/status-categories']);
      },
    );
  }
}
